import { UserRole } from "@edlab-fms/shared";

export function canManageDonors(role: string): boolean {
  return role === UserRole.SUPER_ADMIN;
}

export function canViewDonors(role: string): boolean {
  return (
    role === UserRole.SUPER_ADMIN ||
    role === UserRole.ACCOUNTS ||
    role === UserRole.FINANCE_REVIEWER
  );
}
